import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Server from '../../../functions/server';

class AlertDialog extends React.Component {

  pickList() {
    let orderId = this.props.picklistOrderid;
    if (this.props.type == 'save') {
      let open = Server() + "pdf/picklist.php?orderId="+orderId;
      window.open(open);
    }
    else {
      let open = Server() + "pdf/pickup.php?orderId="+orderId;
      window.open(open);
    }
  }

  render() {
    return (
      <div>
        <Dialog open={this.props.picklistopen} aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">{"Alert Message"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Order is conformed!!!
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.props.closepicklist() } } color="primary">
              Close
            </Button>
            <Button color="primary" onClick={this.pickList.bind(this)} autoFocus>
              Picklist
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default AlertDialog;
